// Import react.
import * as React from 'react';

interface IStickyContainerContext {
	getCurrentLevelStickyOffset: () => number;
	getNextLevelStickyOffset: () => number;
	getCurrentLevelZIndexOffset: () => number;
	getNextLevelZIndexOffset: () => number;
	registerStickyRef: (ref: React.RefObject<HTMLDivElement>) => void;
}

const StickyContainerContext: React.Context<IStickyContainerContext> = React.createContext<IStickyContainerContext>({
	getCurrentLevelStickyOffset: () => 0,
	getNextLevelStickyOffset: () => 0,
	getCurrentLevelZIndexOffset: () => 0,
	getNextLevelZIndexOffset: () => 0,
	registerStickyRef: (ref: React.RefObject<HTMLDivElement>) => { },
});

export default StickyContainerContext;